<template>
  <div class="con">
    <Nav />
    <div class="banner">
      <img src="@/assets/img/banner-news.jpg" alt="" />
      <div class="banner-p">
        <div class="wa">{{ $t("News.bannerT2") }}</div>
        <div class="xian" v-if="$t('language.name') == 'En'"></div>
      </div>
    </div>

    <div class="con-box">
      <div class="newshead">
        <h3>{{ $t("News.titile3") }}</h3>
        <div class="more" @click="goMore">
          <span>{{ $t("News.more") }}</span>
          <img src="@/assets/img/more.png" alt="" />
        </div>
      </div>

      <div class="list">
        <template v-for="(item, i) in list">
          <NewsItem :key="i" :row="item" />
        </template>
      </div>

      <div class="link">
        <label>市场公关部联系方式</label>
        <label>/</label>
        <span>PRMarketing@geelyfintech.com</span>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/views/nav";
import Bus from "@/assets/js/bus";
import { GetNewsList } from "@/api/api";
import NewsItem from "./newsItem";
export default {
  name: "News",
  components: {
    Nav,
    NewsItem,
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    console.log(localStorage.getItem("languageSet"), 21);
    this.getData();
  },
  methods: {
    checkNav(url) {
      if (this.$route.path != url) {
        Bus.$emit("nav", url);
        this.$router.push(url);
        document.body.scrollTop = 0;
        // firefox
        document.documentElement.scrollTop = 0;
        // safari
        window.pageYOffset = 0;
      }
    },

    getData() {
      GetNewsList({ pageIndex: 0, pageSize: 3 }).then((res) => {
        // console.log(res);
        var { code, data } = res;

        if (code === 0) {
          if (data.data instanceof Array) {
            for (let i = 0; i < data.data.length; i++) {
              const row = data.data[i];
              if (row.imageUrl) {
                var pattern = /https:\/\/www.westmoney10.com\/api\/cos/g
                row.imageUrl = row.imageUrl.replace(pattern, process.env.VUE_APP_COS_BASE_URL)
              }
            }
          }
          this.list = data.data || [];
        }
      });
    },

    goMore() {
      this.$router.push({
        path: "/news/list",
      });
    },
  },
};
</script>

<style scoped lang="less">
.con {
  width: 100%;
  height: 100%;
  background: #f8f8f8;
  min-width: 1260px;
  position: relative;

  .banner {
    width: 100%;
    height: 387px;
    display: flex;
    position: relative;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    margin-bottom: 80px;

    img {
      height: 100%;
    }

    .banner-p {
      width: 1260px;
      height: 70px;
      position: absolute;
      top: 158px;
      left: 50%;
      margin-left: -630px;
      padding-left: 80px;
      box-sizing: border-box;

      .wa {
        float: left;
        font-style: normal;
        font-weight: 500;
        font-size: 44px;
        line-height: 70px;
        color: #fff;
      }

      .xian {
        float: left;
        background: #fff;
        width: 90px;
        height: 2px;
        margin-top: 34px;
        margin-left: 50px;
      }
    }
  }

  .con-box {
    width: 1200px;
    box-sizing: border-box;
    margin: 0 auto;
    padding-bottom: 80px;

    .newshead {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      h3 {
        font-weight: 500;
        font-size: 20px;
        line-height: 24px;
        color: #242a32;
      }

      .more {
        display: flex;
        justify-content: center;
        align-items: center;

        color: #2284f6;
        font-size: 16px;
        cursor: pointer;

        img {
          height: 12px;
          margin-left: 10px;
        }
      }
    }

    .list {
      display: flex;
      justify-content: space-between;
    }
  }

  .link {
    margin-top: 80px;

    label {
      font-weight: 500;
      font-size: 20px;
      margin-right: 15px;
    }

    span {
      font-size: 20px;
      color: #2284F6;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/news/index.vue